import React from 'react';
import { PenTool, Settings, GitMerge, User, ArrowRight } from 'lucide-react';

const features = [
  {
    icon: PenTool,
    title: "Individuelle Planung statt Standardpakete",
    description: "Jede Photovoltaikanlage wird individuell für Ihr Gebäude, Ihren Energieverbrauch und Ihre zukünftigen Bedürfnisse geplant – keine Lösung von der Stange.",
    color: "sun-orange"
  },
  {
    icon: Settings,
    title: "Technische Systemkompetenz",
    description: "Tiefgreifendes Verständnis der Photovoltaik-Technologie und komplexer Energiesysteme durch langjährige Branchenerfahrung in Entwicklung und Qualitätsmanagement.",
    color: "sun-blue"
  },
  {
    icon: GitMerge,
    title: "Ganzheitliche Energiekonzepte",
    description: "Integration von Solarstrom, Speicher, Elektromobilität und Wärmeerzeugung zu einem intelligenten Gesamtsystem – alles aus einer Hand.",
    color: "emerald"
  },
  {
    icon: User,
    title: "Persönliche Betreuung",
    description: "Direkte Beratung und Projektbegleitung vom Erstkontakt über die Planung bis zur Inbetriebnahme – und darüber hinaus. Kein Callcenter, sondern persönlicher Ansprechpartner.",
    color: "violet"
  }
];

const colorMap = {
  'sun-orange': { bg: 'bg-sun-orange/10', icon: 'text-sun-orange', hover: 'group-hover:bg-sun-orange' },
  'sun-blue': { bg: 'bg-sun-blue/10', icon: 'text-sun-blue', hover: 'group-hover:bg-sun-blue' },
  'emerald': { bg: 'bg-emerald-100', icon: 'text-emerald-600', hover: 'group-hover:bg-emerald-500' },
  'violet': { bg: 'bg-violet-100', icon: 'text-violet-600', hover: 'group-hover:bg-violet-500' }
};

const WhySunprojectsSection = () => {
  const scrollToContact = () => {
    const kontaktElement = document.querySelector('#kontakt');
    if (kontaktElement) {
      kontaktElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section data-testid="why-sunprojects-section" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-sun-orange/10 text-sun-orange rounded-full text-sm font-semibold mb-4">
            Unser Ansatz
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Warum
            <span className="text-sun-orange"> Sunprojects</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Was uns von anderen Photovoltaik-Anbietern unterscheidet: Echte Expertise, 
            individuelle Lösungen und persönliche Betreuung.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            const colors = colorMap[feature.color];
            
            return (
              <div
                key={index}
                data-testid={`why-sunprojects-card-${index}`}
                className="group bg-gradient-to-br from-slate-50 to-white rounded-2xl p-8 border border-slate-100 hover:border-sun-orange/30 hover:shadow-xl hover:shadow-sun-orange/5 transition-all duration-300"
              >
                <div className="flex items-start gap-5">
                  <div className={`w-16 h-16 ${colors.bg} rounded-2xl flex items-center justify-center flex-shrink-0 ${colors.hover} transition-colors`}>
                    <IconComponent className={`w-8 h-8 ${colors.icon} group-hover:text-white transition-colors`} />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-slate-900 mb-3">{feature.title}</h3>
                    <p className="text-slate-600 leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={scrollToContact}
            data-testid="why-sunprojects-cta"
            className="inline-flex items-center gap-2 bg-sun-orange hover:bg-sun-orange-dark text-white px-8 py-4 rounded-full font-semibold shadow-lg shadow-sun-orange/30 transition-all hover:scale-105"
          >
            Persönliche Beratung anfragen
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default WhySunprojectsSection;
